var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.$t("CargoMsg.Cargo_RoleGroupManagement"),
        width: "80%",
        height: "800px",
        "close-on-click-modal": false
      },
      on: { close: _vm.handleClose }
    },
    [
      _c("div", { staticClass: "role-group-container" }, [
        _c(
          "div",
          { staticClass: "left-panel" },
          [
            _c("div", { staticClass: "panel-header" }, [
              _c(
                "div",
                { staticClass: "button-group" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.addRoleGroup }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger", size: "mini" },
                      on: { click: _vm.deleteRoleGroups }
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("CargoMsg.Cargo_Delete")) + " "
                      )
                    ]
                  )
                ],
                1
              )
            ]),
            _c("cargo-ag-grid", {
              staticStyle: { width: "100%", height: "680px" },
              attrs: {
                "show-side-bar": false,
                "column-defs": _vm.left.columnDefs,
                "row-data": _vm.left.rowData,
                "grid-options": _vm.left.gridOptions
              },
              on: {
                gridReady: function(params) {
                  _vm.leftGridApi = params.api
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "right-panel" },
          [
            _c("div", { staticClass: "panel-header" }, [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ApplicationPermission")))
              ])
            ]),
            _c("cargo-ag-grid", {
              staticStyle: { width: "100%", height: "680px" },
              attrs: {
                "show-side-bar": false,
                "column-defs": _vm.officeDeptTree.columnDefs,
                "row-data": _vm.officeDeptTree.rowData,
                "grid-options": _vm.officeDeptTree.gridOptions
              },
              on: {
                gridReady: function(params) {
                  _vm.rightGridApi = params.api
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleConfirm } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
          ),
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }